// extracted by mini-css-extract-plugin
module.exports = {"inputDiv":"Input_inputDiv__2JJmV","input":"Input_input__3PNbO","label":"Input_label__z-LP7"};